import { c as _c } from "react/compiler-runtime";
import HeaderBlock from 'modules/profile/user-plan/components/price-plan-columns/components/header-block';
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum';
import { tableFeatures, UserPlanInterface, UseUserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface';
import { getFeatureLimitTitle } from 'modules/profile/user-plan/utils/price-plan-utils';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export interface UserPlanColumnProps {
  pricePlan: UserPlanInterface;
  billingPeriod: BillingPeriodEnum;
  paymentMethod: UseUserPlanInterface['customer']['paymentMethod'];
  isPlanUpgradeAvailable: boolean;
}
const UserPlanColumn = t0 => {
  const $ = _c(11);
  const {
    pricePlan,
    billingPeriod,
    paymentMethod,
    isPlanUpgradeAvailable
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== billingPeriod || $[1] !== isPlanUpgradeAvailable || $[2] !== paymentMethod || $[3] !== pricePlan) {
    t1 = <HeaderBlock pricePlan={pricePlan} billingPeriod={billingPeriod} paymentMethod={paymentMethod} isPlanUpgradeAvailable={isPlanUpgradeAvailable} />;
    $[0] = billingPeriod;
    $[1] = isPlanUpgradeAvailable;
    $[2] = paymentMethod;
    $[3] = pricePlan;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== pricePlan || $[6] !== t) {
    t2 = tableFeatures.map((column, index) => <React.Fragment key={`column-${column.key}`}><div className="text-text-primary truncate text-center text-base">{getFeatureLimitTitle({
          pricePlan,
          key: column.key,
          t
        })}</div>{tableFeatures[index + 1] ? <hr className="border-border-200 -mr-6 border-solid" /> : <div />}</React.Fragment>);
    $[5] = pricePlan;
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <div className="desktop:grid flex w-full min-w-full snap-start flex-col gap-2 border border-transparent">{t1}{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
export default UserPlanColumn;